import React from 'react'
import Navbar from 'components/Navbar'
import UserNavbarSection from 'modules/user/components/UserNavbarSection'
import Link from 'components/Link'
import { routes } from 'constants/routes'
import { ReactComponent as CrossIcon } from 'icons/cross-20.svg'

interface EmptyNavbarProps {
  title?: string
  onClickClose?: () => void
  hideLogo?: boolean
  hideUser?: boolean
}

const EmptyNavbar = ({
  onClickClose,
  title,
  hideLogo,
  hideUser,
}: EmptyNavbarProps) => (
  <Navbar>
    <Navbar.Section flex={0}>
      {onClickClose && (
        <>
          <Navbar.Button icon={CrossIcon} onClick={onClickClose} />
          <Navbar.Divider />
        </>
      )}
      {!onClickClose && !hideLogo && (
        <>
          <Link to={routes.ENTRY.create({})}>
            <Navbar.Logo />
          </Link>
          <Navbar.Divider />
        </>
      )}
    </Navbar.Section>
    {title && <Navbar.Title>{title}</Navbar.Title>}
    {!hideUser && (
      <Navbar.Section align="end">
        <Navbar.Divider />
        <UserNavbarSection />
      </Navbar.Section>
    )}
  </Navbar>
)

export default EmptyNavbar
